import React from 'react'
import ReactDOM from 'react-dom'
import feeder from '../images/logo-feeder-large.png'
import sca from '../images/logo-sca.png'
import fcc from '../images/AgExpert_banner_585x90.jpg'
import agnition from '../images/logo-agnition-brought-large.png'
import _ from 'lodash'

class Footer extends React.Component {
  updateFooterImages() {
    const feederButton = <img src={feeder} alt="Feeder Logo" />
    const scaButton = <img src={sca} alt="SCA Logo" />
    const fccButton = (
      <a
        href="https://www.fcc-fac.ca/en/software/agexpert.html"
        target="_blank"
      >
        <img src={fcc} alt="Farm Credit Canada Logo" />
      </a>
    )
    const agnitionButton = (
      <img src={agnition} alt="Brought to you by Agnition" />
    )
    var element = ''
    const myLocation = window.location.href
    if (
      _.includes(myLocation, 'futures') ||
      _.includes(myLocation, 'price') ||
      _.includes(myLocation, 'breakeven') ||
      _.includes(myLocation, 'projections')
    ) {
      if (window.currentButton) {
        if (window.currentButton === 'scaButton') {
          element = feederButton
          window.currentButton = 'feederButton'
        } else if (window.currentButton === 'feederButton') {
          element = scaButton
          window.currentButton = 'scaButton'
        }
      } else {
        element = feederButton
        window.currentButton = 'feederButton'
      }
    } else {
      element = agnitionButton
    }
    ReactDOM.render(fccButton, document.getElementById('button1'))
    ReactDOM.render(element, document.getElementById('button2'))
  }

  componentDidMount() {
    this.updateFooterImages()
    this.timerID = setInterval(() => this.updateFooterImages(), 3000)
  }

  render() {
    return (
      <div>
        <div id="footerImage" className="footer fixed-bottom app-rotator">
          <div className="container">
            <div className="row">
              <div id="button1" className="footerButton col-xs-6" />
              <div id="button2" className="footerButton col-xs-6" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js